import type { HTMLAttributes } from 'react';
import { cn } from './cn';

/** `interactive` adds the hover lift — use it only on cards that are links or buttons. */
export function Card({ className, interactive, ...rest }: HTMLAttributes<HTMLDivElement> & { interactive?: boolean }) {
  return <div className={cn('rounded-[16px] border border-line bg-paper shadow-card', interactive && 'lift', className)} {...rest} />;
}

type Tone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';
const tones: Record<Tone, string> = {
  success: 'bg-success-light text-success',
  warning: 'bg-warning-light text-warning',
  danger: 'bg-danger-light text-danger',
  info: 'bg-primary-light text-navy',
  neutral: 'bg-fill text-ink-2',
};
export function Badge({ tone = 'neutral', className, ...rest }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return <span className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold', tones[tone], className)} {...rest} />;
}
